import { AnswerConfig } from '../types/GameplayTypes';

export function totalPoints(answers: AnswerConfig[]): number {
	return answers
		.filter(answer => answer.text.trim())
		.reduce((sum, answer) => sum + answer.points, 0);
}

export function calculateFixedPoints(answers: AnswerConfig[]): AnswerConfig[] {
	const total = totalPoints(answers);
	const validAnswers = answers.filter(a => a.text.trim());

	if (validAnswers.empty() || (total === 100)) {
		return answers;
	}

	// Sort by points descending
	const sortedIndices = answers
		.filter(a => a.text.trim())
		.sort((a, b) => b.points - a.points)
		.map((_a, i) => i);

	const diff = 100 - total;
	const fixedAnswers = [...answers];

	if (diff > 0) {
		addPointsDistributed(fixedAnswers, diff, sortedIndices);
	} else {
		removePointsDistributed(fixedAnswers, diff, sortedIndices);
	}

	return fixedAnswers;
}

/** Distribute pointsToAdd, starting with highest scoring answers */
function addPointsDistributed(answers: AnswerConfig[], pointsToAdd: number, sortedIndices: number[]) {
	let remaining = pointsToAdd;
	let indexIndex = 0;

	while ((remaining > 0) && (indexIndex < sortedIndices.length)) {
		const answerIndex = sortedIndices[indexIndex];
		if (answerIndex !== undefined) {
			const currentAnswer = answers[answerIndex];
			if (currentAnswer) {
				answers[answerIndex] = { ...currentAnswer, points: currentAnswer.points + 1 };
			}
		}
		remaining--;
		indexIndex = (indexIndex + 1) % sortedIndices.length;
	}
}

/** Distribute pointsToRemove, starting with highest scoring answers */
function removePointsDistributed(answers: AnswerConfig[], pointsToRemove: number, sortedIndices: number[]) {
	let remaining = Math.abs(pointsToRemove);
	let indexIndex = 0;

	while ((remaining > 0) && (indexIndex < sortedIndices.length)) {
		const answerIndex = sortedIndices[indexIndex];
		if (answerIndex !== undefined) {
			const currentAnswer = answers[answerIndex];
			if (currentAnswer && (currentAnswer.points > 0)) {
				answers[answerIndex] = { ...currentAnswer, points: currentAnswer.points - 1 };
				remaining--;
			}
		}
		indexIndex = (indexIndex + 1) % sortedIndices.length;
	}
}